/**
 * Brief-received indicator — collapses the kickstart brief workflow
 * into a binary signal so PMO and department leads can scan a list
 * of requested projects and see at a glance which ones have a brief
 * in hand before approving them into the active queue.
 *
 * "Received" = brief is submitted or approved.
 * "Not Received" = brief is draft, missing, or anything else.
 *
 * Extracted from Portfolio.tsx so the DepartmentPortfolio "Pending
 * Approval" section can render the same pill without duplicating the
 * logic.
 */

export function BriefBadge({ status }: { status: string | null | undefined }) {
  const received = status === "submitted" || status === "approved";
  if (received) {
    return (
      <span className="inline-flex items-center rounded-md border border-emerald-200 dark:border-emerald-500/30 bg-emerald-100 dark:bg-emerald-500/15 px-2 py-0.5 text-xs font-medium text-emerald-800 dark:text-emerald-300">
        Received
      </span>
    );
  }
  return (
    <span className="inline-flex items-center rounded-md border border-line bg-canvas px-2 py-0.5 text-xs font-medium text-ink-muted">
      Not Received
    </span>
  );
}
